<div style="display: flex; flex-direction: column; gap: 16px; padding: 16px; height: 100%">
  <div style="flex: 0 1 auto; max-height: 40%; min-height: 60px; overflow: auto">
    <ebw-monorepo-feature-viewer-tree
      [features]="features"
      (nodeSelected)="onNodeSelected($event)"
      [simple]="true"
    ></ebw-monorepo-feature-viewer-tree>
  </div>
  <div *ngIf="selectedNode !== undefined && detailData.length !== 0" class="chart-scroll-container">
    <div class="chart-grid">
      <div class="chart-item" *ngFor="let chart of detailData">
        <p class="chart-title">{{ chart.name | normalize }}</p>
        <div class="chart-wrapper" #chartWrapper>
          <ebw-monorepo-rischio-analitico-trend-chart [series]="chart.series" [yAxisLabel]="chart.yLabel"></ebw-monorepo-rischio-analitico-trend-chart>
        </div>
        <p class="chart-subtitle">Distribuzione dei valori</p>
        <ebw-monorepo-rischio-analitico-distribuzione-chart
          [distribuzione]="chart.distribuzione"
          [unitaMisura]="chart.yLabel"
          [osservazioni]="chart.series"
        ></ebw-monorepo-rischio-analitico-distribuzione-chart>
      </div>
    </div>
  </div>

  <div *ngIf="!selectedNode" class="chart-scroll-container">
    <div class="viewer-details__cards">
      <div class="info-box">
        <mat-icon class="info-box__icon">info_outline</mat-icon>
        <div class="info-box__text">Seleziona un elemento per visualizzare il suo dettaglio</div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedNode && erroreDettaglio" class="chart-scroll-container">
    <div class="viewer-details__cards">
      <div class="info-box">
        <mat-icon class="info-box__icon">error_outline</mat-icon>
        <div class="info-box__text">{{ erroreDettaglio }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedNode && !hasSelectedAnalytes" class="chart-scroll-container">
    <div class="viewer-details__cards">
      <div class="info-box">
        <mat-icon class="info-box__icon">info_outline</mat-icon>
        <div class="info-box__text">
          Per visualizzare il trend e la distribuzione dei valori seleziona uno o più analiti nel filtro «Analiti» e premi Applica.
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="selectedNode && hasSelectedAnalytes && !erroreDettaglio && !caricamentoDettaglio && detailData.length === 0"
    class="chart-scroll-container"
  >
    <div class="viewer-details__cards">
      <div class="info-box">
        <mat-icon class="info-box__icon">warning</mat-icon>
        <div class="info-box__text">Nessun prelievo per gli analiti selezionati nel periodo considerato.</div>
      </div>
    </div>
  </div>
</div>
